export const CACHE_KEY_PROFILE_EDIT = 'profile-edit';
export const CACHE_KEY_PROFILE_PHOTO_EDIT = 'profile-photo-edit';
